import QueryString from "query-string";
import React, { useCallback, useEffect } from "react";
import { Button, Container, Row, Col } from "reactstrap";
import Content from "../layout/Content";
import { Header2 } from "../layout/Header2";
import Layout from "../layout/Layout";
import { useMeCore } from "../../cores/me";
import { useRouterCore } from "../../cores/router";
import { UpdateLoadingCard } from "../component/UpdateLoadingCard";
import { BOARD_CARD_LOADING, TASKS_LOADING } from "../../constants/loading.constant";
import { useTaskCore } from "../../cores/tasks";
import { NoData } from "../component/NoData";
import { BOARD_CARD_MODAL, TASK_CARD_MODAL } from "../../constants/modal.constant";
import { useGlobalCore } from "../../cores/globals";
import { useIntl } from "react-intl";
import TaskDetails from "../component/tasks/modal/TaskDetails";
import { useCompanyCore } from "../../cores/company";
import { TaskRow } from "../component/tasks/TaskRow";
import { TasksBar } from "../component/tasks/TasksBar";
import { useLocation } from "react-router-dom";
import TaskSideModals from "../component/tasks/TaskSideModals";
import ConstactSideModals from "../component/contacts/ContactSideModals";
import CompanySideModals from "../component/contactCompanies/CompanySideModals";
import BoardSideModals from "../component/boards/BoardSideModals";
import EventSideModals from "../component/event/EventSideModals";
import EmailSideModals from "../component/gmail/EmailSideModals";
import { Errors } from "../../constants/errors";
import { CARD_PRODUCT } from "../../constants/internalModal.constant";
import SideModal from "../layout/SideModal";
import { useBoardCore } from "../../cores/boards";

export const TasksScreen = () => {
  const intl = useIntl();
  const { search } = useLocation();
  const { companyPlan, company, companyRole, isAdmin, isReseller } = useMeCore();
  const { getCompany } = useCompanyCore();
  const { cleanCard, errorCode } = useBoardCore();
  const { goToSocial } = useRouterCore();
  const { tasks, total, clearTask } = useTaskCore();
  const {
    isModal,
    turnOffModal,
    turnOnModal,
    getModalVisibility,
    getModalContent,
    isLoading,
    turnOffInternalModal,
  } = useGlobalCore();


  useEffect(() => {
    if (
      !companyPlan?.rules.allowBusinessBoard || (
        !companyRole?.crm &&
        !companyRole?.owner &&
        !companyRole?.admin &&
        !companyRole?.agent &&
        !isAdmin &&
        !isReseller
      )
    ) goToSocial();
  }, [companyPlan, companyRole, isAdmin, isReseller, goToSocial]);

  useEffect(() => {
    const { taskId } = QueryString.parse(search);
    if (taskId) {
      turnOnModal(
        TASK_CARD_MODAL,
        <TaskDetails task={taskId as string} />
      );
    }
  }, [search, turnOnModal]);

  useEffect(() => {
    getCompany(company?.id!);
  }, [getCompany, company]);

  const toggleSideModal = useCallback(() => {
    clearTask();
    turnOnModal(TASK_CARD_MODAL, <TaskDetails />);
  }, [turnOnModal, clearTask]);

  return (
    <Layout>
      <Header2
        title={`${intl.formatMessage({ id: "app.crmTasks.tasks" })} (${total})`}
        rightChildren={
          <Button className="whiteButton" onClick={toggleSideModal}>
            {intl.formatMessage({ id: "app.crmTasks.CreateTasks" })}
          </Button>       
        }
      />
      <Content>
        <Container fluid>
          <Row>
            <Col xs="12">
              <UpdateLoadingCard
                loadingId={TASKS_LOADING}
                text={intl.formatMessage({ id: "app.crmTasks.updatingTasks" })}
              />
              <TasksBar />
              <Container>
                {tasks.map((task) => (
                  <TaskRow key={task.id} task={task} />
                ))}
                {!tasks.length && (
                  <NoData
                    image="generic4"
                    text={intl.formatMessage({ id: "app.crmTasks.updatingTasks" })}
                    actionLabel= {intl.formatMessage({ id: "app.crmTasks.noTasks" })}
                    action={toggleSideModal}
                    horizontal
                  />
                )}
              </Container>
            </Col>
          </Row>
        </Container>
      </Content>

      <SideModal
        active={isModal(BOARD_CARD_MODAL)}
        visible={getModalVisibility(BOARD_CARD_MODAL)}
        onClose={() => {
          turnOffModal(BOARD_CARD_MODAL);
          turnOffInternalModal(CARD_PRODUCT);
          cleanCard();
        }}
        showSppiner={isLoading(BOARD_CARD_LOADING)}
        showError={errorCode === Errors.CardLoad}
      >
        {getModalContent(BOARD_CARD_MODAL)}
      </SideModal>

      <TaskSideModals />
      <ConstactSideModals />
      <CompanySideModals />
      <BoardSideModals />
      <EventSideModals />
      <EmailSideModals />
    </Layout>
  );
};
